import useInventoryDetails from "./useInventoryDetails";
import useInventoryStatusDetails from "./useInventoryStatusDetails";
import InventoryDetails from "./InventoryDetails";
import InventoryStatusDetails from "./InventoryStatusDetails";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const InventoryInfo = () => {
  const { 
    inventoryDetailsForm, 
    requiredFields, 
    isLoadingExisting, 
    onSubmitInventoryDetails,
  } = useInventoryDetails();

  const {
    inventoryStatusForm,
    isLoadingInventoryStatus,
    onSubmitInventoryStatus,
    handleDeleteInventoryStatus,
  } = useInventoryStatusDetails();

  const loggedInUserData = useSelector(
      (state: RootState) => state.currentData.loggedInUserData
    );
  
    // 👇 backend sends role as array, e.g. ["CRM_HEAD"]
    const roles = loggedInUserData?.role || [];
  
    // Helper to check if user has a given role
    const hasRole = (role: string) => Array.isArray(roles) && roles.includes(role);

  return (
    <div className="px-8 py-6">
      {/* Inventory Details Section */}
      <InventoryDetails
        inventoryDetailsForm={inventoryDetailsForm}
        requiredFields={requiredFields}
        isLoadingExisting={isLoadingExisting}
        onSubmitInventoryDetails={onSubmitInventoryDetails}
      />

      {/* Inventory Status Section */}
      {!hasRole("LABS_TEAM") && (
      <InventoryStatusDetails
        inventoryStatusForm={inventoryStatusForm}
        isLoadingExisting={isLoadingExisting}
        isLoadingInventoryStatus={isLoadingInventoryStatus}
        onSubmitInventoryStatus={onSubmitInventoryStatus}
        handleDeleteInventoryStatus={handleDeleteInventoryStatus}
      />
      )}
    </div>
  );
};

export default InventoryInfo;